import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';

import {
  centsToDollars,
  dateToTimestamp,
  dollarsToCents,
  timestampToDate,
} from '../../../utils/fieldNormalizers';

import type { ClockEntry } from './_types';

export function normalizeClockEntry(entry: any): ClockEntry {
  const normalized = camelcaseKeys(entry, { deep: true });

  return {
    ...normalized,
    endDate: timestampToDate(normalized.endDate),
    startDate: timestampToDate(normalized.startDate),
    payrate: centsToDollars(normalized.payrate),
    pay: centsToDollars(normalized.pay),
  };
}

export interface ClockEntryAggregates {
  totalHours: number;
  totalPay: number;
  averagePayrate: number;
}

export function normalizeClockEntryAggregates(
  aggregates: any
): ClockEntryAggregates {
  const normalized = camelcaseKeys(aggregates, { deep: true });
  return {
    ...normalized,
    averagePayrate: centsToDollars(normalized.averagePayrate),
    totalPay: centsToDollars(normalized.totalPay),
  };
}

export function denormalizeClockEntry(entry: Partial<ClockEntry>): any {
  if (entry.payrate) {
    entry.payrate = dollarsToCents(entry.payrate);
  }

  const obj = decamelizeKeys(entry, { deep: true });

  return {
    ...obj,
    start_date: dateToTimestamp(entry.startDate),
    end_date: dateToTimestamp(entry.endDate),
  };
}
